import React from "react";
import { Typography } from "@mui/material";
import { UserType } from "../../../../../../models/userType";
import { Cell, Row, SelectField, bySchool } from "./fields";

/**
 * Which students this user may see. The backend compiles the choice into
 * people_user's predicate; offering only choices keeps free text out of it.
 */
const TrainingProfile = ({
  form,
  schools,
  domains,
}: {
  form: any;
  schools: any[];
  domains: string[];
}) => {
  const clientTypeIndex = form.values.client_type?.client_type_index;

  if (clientTypeIndex === UserType.Index.LWS_SCHOOL) {
    return (
      <Row>
        <SelectField
          id="user_school"
          label="School(s)"
          xs={8}
          form={form}
          options={schools}
          {...bySchool}
        />
      </Row>
    );
  }

  if (clientTypeIndex === UserType.Index.LWS_DEALER) {
    return (
      <Row>
        <SelectField id="user_domain" label="Domain(s)" xs={8} form={form} options={domains} />
      </Row>
    );
  }

  // LWS_ADMIN and LWS_SUPPORT see everything — say so, don't show an empty row.
  return (
    <Row>
      <Cell xs={12}>
        <Typography variant="body2" sx={{ fontStyle: "italic" }}>
          This training role sees all students; there is no school or domain to set.
        </Typography>
      </Cell>
    </Row>
  );
};

export default TrainingProfile;
